var EEcommerceSystemName;
(function(EEcommerceSystemName) {
    EEcommerceSystemName["Paddle"] = "Paddle";
})(EEcommerceSystemName || (EEcommerceSystemName = {}));
var EEcommerceSystemEnvironment;
(function(EEcommerceSystemEnvironment) {
    EEcommerceSystemEnvironment["Production"] = "production";
    EEcommerceSystemEnvironment["Sandbox"] = "sandbox";
})(EEcommerceSystemEnvironment || (EEcommerceSystemEnvironment = {}));
export { EEcommerceSystemName, EEcommerceSystemEnvironment };
